/* ============
 * Organization Member Transformer
 * ============
 *
 * The transformer for the organization type.
 */

import Transformer from './transformer';

export default class OrganizationMemberTransformer extends Transformer {
  static fetch(organizationMember) {
    return {
      id: organizationMember.id,
      user: organizationMember.user,
      title: organizationMember.title,
      color: organizationMember.color,
      isAccepted: organizationMember.is_accepted,
      organizationMemberProducts: organizationMember.organization_member_products,
    };
  }

  static send(organizationMember) {
    return {
      first_name: organizationMember.firstname,
      last_name: organizationMember.lastname,
      email: organizationMember.email,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/organizationMember.js